import React from 'react';
import MySeriesCard from '../MySeriesCard';
import DeleteConfirmationModal from "../../../DeleteConfirmationModal";
import MySeriesTableBody from "./MySeriesTableBody";


const MySeriesTableCard = ({
  series,
  setSelectedSeries,
  handleSeriesAction,
  handleDeleteConfirm,
  seriesNameToDelete,
  isDeleteModalOpen,
  setIsDeleteModalOpen,
                               handleSave,
                               editingSeries,
                               setEditingSeries,
                               publishTime,
                               handlePublishTimeChange
}) => {
  return <MySeriesCard>
      <h3 className='text-2xl font-semibold mb-6 text-gray-800'>Series</h3>
      <div className='overflow-x-auto'>
        <table className='min-w-full divide-y divide-gray-200'>
          <thead className='bg-gray-50'>
            <tr>
              {[
                'Series Name',
                'Status',
                'Language',
                'Platforms',
                'Voice',
                'Created On',
                'Actions',
              ].map((header) => (
                <th
                  key={header}
                  className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <MySeriesTableBody  publishTime={publishTime} setEditingSeries={setEditingSeries} handlePublishTimeChange={handlePublishTimeChange} editingSeries={editingSeries} handleSave={handleSave} series={series} setSelectedSeries={setSelectedSeries} handleSeriesAction={handleSeriesAction}/>
        </table>
      </div>
      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleDeleteConfirm}
        confirmationMessage={ `Are you sure you want to delete the series ${seriesNameToDelete}? This action
          cannot be undone.`}
      />
    </MySeriesCard>

};

export default MySeriesTableCard;
